
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire7455"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire7455"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("kdrAP", function(module, exports) {

var $yZzij = parcelRequire("yZzij");
// ---------- helpers ----------
const $eb7a6cf340d32bbf$var$ensureHtml = (s)=>/\.html?$/i.test(s) ? s : `${s}.html`;
const $eb7a6cf340d32bbf$var$strip = (s)=>String(s).replace(/^\/+|\/+$/g, "");
const $eb7a6cf340d32bbf$var$join = (...parts)=>"/" + parts.filter(Boolean).map($eb7a6cf340d32bbf$var$strip).join("/");
const $eb7a6cf340d32bbf$var$toAbs = (u)=>/^[a-z]+:/i.test(u) ? u : `${location.origin}${u.startsWith("/") ? u : "/" + u}`;
function $eb7a6cf340d32bbf$var$resolveToken(tok = "") {
    tok = tok.trim();
    if (tok.startsWith("app:")) return $eb7a6cf340d32bbf$var$join("/app/pages", $eb7a6cf340d32bbf$var$ensureHtml(tok.slice(4).trim()));
    if (tok.startsWith("site:")) return $eb7a6cf340d32bbf$var$join($eb7a6cf340d32bbf$var$ensureHtml(tok.slice(5).trim()));
    return tok;
}
function $eb7a6cf340d32bbf$var$wireLinks(scope = document) {
    scope.querySelectorAll("a[data-href]").forEach((a)=>{
        const path = $eb7a6cf340d32bbf$var$resolveToken(a.getAttribute("data-href") || "");
        a.setAttribute("href", $eb7a6cf340d32bbf$var$toAbs(path));
        a.removeAttribute("data-href");
    });
}
function $eb7a6cf340d32bbf$var$sanitize(html) {
    try {
        const doc = new DOMParser().parseFromString(String(html), "text/html");
        doc.querySelectorAll('script, link[rel="stylesheet"], link[rel="modulepreload"]').forEach((n)=>n.remove());
        return doc.body.innerHTML || String(html);
    } catch  {
        return String(html);
    }
}
// ---------- core loader (FRAG_URLS-first) ----------
const $eb7a6cf340d32bbf$var$fetchCache = new Map();
async function $eb7a6cf340d32bbf$var$loadFragment(rawKey) {
    const key = String(rawKey || "").trim();
    if (!key) return "";
    // Prefer a Parcel-managed URL (no SPA fallbacks, always served)
    const parcelUrl = (0, $yZzij.FRAG_URLS)?.[key];
    if (parcelUrl) {
        if (!$eb7a6cf340d32bbf$var$fetchCache.has(parcelUrl)) $eb7a6cf340d32bbf$var$fetchCache.set(parcelUrl, fetch(parcelUrl).then((r)=>r.ok ? r.text() : ""));
        const viaParcel = await $eb7a6cf340d32bbf$var$fetchCache.get(parcelUrl);
        if (viaParcel && viaParcel.trim()) return viaParcel;
    }
    // Final fallback: fetch by resolved path (useful on simple static servers)
    const resolved = $eb7a6cf340d32bbf$var$resolveToken(key);
    const path = $eb7a6cf340d32bbf$var$ensureHtml(resolved.startsWith("/") ? resolved : "/" + resolved);
    const abs = $eb7a6cf340d32bbf$var$toAbs(path);
    if (!$eb7a6cf340d32bbf$var$fetchCache.has(abs)) $eb7a6cf340d32bbf$var$fetchCache.set(abs, fetch(abs).then((r)=>r.ok ? r.text() : ""));
    const fetched = await $eb7a6cf340d32bbf$var$fetchCache.get(abs);
    if (fetched && fetched.trim()) return fetched;
    console.warn("[loader] include miss", {
        raw: key,
        triedParcel: parcelUrl || null,
        triedPath: abs,
        keys: Object.keys((0, $yZzij.FRAG_URLS) || {})
    });
    return "";
}
async function $eb7a6cf340d32bbf$export$ac8d2aa64d563fe1() {
    const nodes = [
        ...document.querySelectorAll("[data-include]:not([data-included])")
    ];
    await Promise.all(nodes.map(async (el)=>{
        const raw = el.getAttribute("data-include") || "";
        const html = await $eb7a6cf340d32bbf$var$loadFragment(raw);
        const wrapper = document.createElement("div");
        wrapper.innerHTML = html ? $eb7a6cf340d32bbf$var$sanitize(html) : `<div class="text-sm text-red-700 bg-red-50 border border-red-200 p-2 rounded">Missing include: ${raw}</div>`;
        // ✅ Instead of replacing the <div> itself, replace only its children
        while(el.firstChild)el.removeChild(el.firstChild);
        for (const child of [
            ...wrapper.children
        ])el.appendChild(child);
        el.setAttribute("data-included", "1");
        $eb7a6cf340d32bbf$var$wireLinks(el);
    }));
    $eb7a6cf340d32bbf$var$wireLinks(document);
    // ✅ Notify that all includes are loaded (optional global hook)
    document.dispatchEvent(new Event("includes:ready"));
    return true;
}
// ---------- expose + boot ----------
window._irecruit = {
    FRAG_URLS: $yZzij.FRAG_URLS,
    injectIncludes: $eb7a6cf340d32bbf$export$ac8d2aa64d563fe1,
    wireLinks: $eb7a6cf340d32bbf$var$wireLinks
};
if (!window.__irecruitLoaderBooted) {
    window.__irecruitLoaderBooted = true;
    async function startIncludes() {
        await $eb7a6cf340d32bbf$export$ac8d2aa64d563fe1();
        // 🔹 Dispatch global ready event
        document.dispatchEvent(new Event("includes:ready"));
        console.log("[loader] includes:ready fired");
    }
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", startIncludes, {
        once: true
    });
    else startIncludes();
}

});
parcelRegister("yZzij", function(module, exports) {

$parcel$export(module.exports, "FRAG_URLS", () => $78bc8c922fa31da1$export$54d52d02707458fa);
// parcel-served URLs

var $lVbMk = parcelRequire("lVbMk");

var $4XrHc = parcelRequire("4XrHc");

var $1r8Ha = parcelRequire("1r8Ha");

var $kUetv = parcelRequire("kUetv");

var $ifTca = parcelRequire("ifTca");

var $4InwM = parcelRequire("4InwM");
const $78bc8c922fa31da1$export$54d52d02707458fa = {
    "/includes/header.html": (0, (/*@__PURE__*/$parcel$interopDefault($lVbMk))),
    "/includes/hero.html": (0, (/*@__PURE__*/$parcel$interopDefault($4XrHc))),
    "/includes/features.html": (0, (/*@__PURE__*/$parcel$interopDefault($1r8Ha))),
    "/includes/workflow.html": (0, (/*@__PURE__*/$parcel$interopDefault($kUetv))),
    "/includes/pricing.html": (0, (/*@__PURE__*/$parcel$interopDefault($ifTca))),
    "/includes/footer.html": (0, (/*@__PURE__*/$parcel$interopDefault($4InwM)))
};

});
parcelRegister("lVbMk", function(module, exports) {
module.exports = import.meta.resolve("8QR8Q");

});

parcelRegister("4XrHc", function(module, exports) {
module.exports = import.meta.resolve("9dGQe");

});

parcelRegister("1r8Ha", function(module, exports) {
module.exports = import.meta.resolve("LxdXl");

});

parcelRegister("kUetv", function(module, exports) {
module.exports = import.meta.resolve("hRvcr");

});

parcelRegister("ifTca", function(module, exports) {
module.exports = import.meta.resolve("kwQHp");

});

parcelRegister("4InwM", function(module, exports) {
module.exports = import.meta.resolve("e6U5F");

});




parcelRequire("kdrAP");
console.log("index entry loaded");


//# sourceMappingURL=public.8cf34b96.js.map
